import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { GenderButton } from 'page/catalog/GendersPanel/GenderButton'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './GendersPanel.module.scss'

export const GendersPanel = observer(() => {
  const demo = useDemo()
  const { options } = demo

  return <Space className={css.pane} gap={4} pad={4} wrap columns>
    <GenderButton gender="" />
    {options.genders?.map(gender => <GenderButton key={gender} gender={gender} />)}
  </Space>
})
